import instance from '@/services/repository';

const resource = '/projects';

export default {
    get(projectId: string) {
        return instance.get(`${resource}/${projectId}/Reports`);
    },
    create(projectId: string, payload: IProjectReport) {
        return instance.post(`${resource}/${projectId}/Reports`, payload);
    },
    update(projectId: string, payload: IProjectReport) {
        return instance.put(`${resource}/${projectId}/Reports`, payload);
    },
    delete(projectId: string, pageId: string) {
        return instance.delete(`${resource}/${projectId}/Reports/${pageId}`);
    },
};
